import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';
import { ModalContext } from '@components/Modals/Modal/config';

import { StringMain } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import bagPng from '/img/icons/bag.png';
import bagWebp from '/img/icons/bag.webp';

const MyPartnersButton: FC = () => {
  const { t } = useTranslation();
  const { openModal } = useContext(ModalContext);
  const invitedFriends = useAppSelector(
    (state) => state.user.referralEarnings?.invitedFriendsCount,
  );

  return (
    <div
      onClick={() =>
        openModal({ renderKind: 'friendsModal', props: undefined })
      }
      className="w-full rounded-xl backdrop-blur-[32px] bg-white/10 p-3 flex items-center h-14 gap-2"
    >
      <Picture
        className="w-8 h-8 shrink-0"
        img={bagPng}
        webp={bagWebp}
        alt="bag"
      />
      <StringMain weight="bold" className="!leading-1.2 flex-1">
        {t('My partners')}
      </StringMain>
      <div className="flex items-center gap-3">
        <StringMain weight="bold" className="!leading-1.2">
          {invitedFriends || 0}
        </StringMain>
        <ChevronIcon className="w-4 h-4 shrink-0 -scale-x-[1] !text-white/40" />
      </div>
    </div>
  );
};

export { MyPartnersButton };
